<template>
  <v-container>
    <v-row class="flex-column" justify="center">
      <div class="text-h6">Ma commande</div>

      <div class="pt-5" style="font-size: 12px;">
        Inscrivez le code du produit désiré dans la colonne « Code SAQ »
        et appuyez sur OK ou sur la touche ENTRÉE.
      </div>
      <div class="pb-5" style="font-size: 12px;">
        Indiquez ensuite la quantité de bouteilles désirées dans la colonne «
        Qté btle(s)».
      </div>

      <v-layout>
        <v-flex>
          <v-layout>
            <v-flex md2 pt-1 style="font-size: 12px;">Commentaires (falcultatif) :</v-flex>
            <v-flex md8>
              <v-textarea
                v-model="commande.commentaire"
                style="font-size: 12px;"
                clearable
                dense
                maxlength="500"
                counter="500"
                outlined
                rows="2"
              />
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>

      <!-- ------------- -->
      <!-- Ajout produit -->
      <!-- ------------- -->

      <div class="messageErreur pl-3">{{ messageProduitInactif }}</div>
      <v-col class="my-2 mx-0 pa-0 d-flex justify-space-between align-center">
        <v-col cols="3" class="mx-2 my-0 pa-0 d-flex align-center justify-start">
          <v-text-field
            v-model.trim="idProduitAjout"
            v-mask="idProduitAjoutMask"
            class="pa-0"
            single-line
            hide-details
            label="ID produit"
            @keyup.enter.native="ajouterProduit"
          />
          <v-btn
            medium
            color="primary"
            style="text-transform: none;"
            :disabled="!idProduitAjout"
            @click="ajouterProduit"
          >Ajouter</v-btn>
        </v-col>

        <v-btn
          class="button"
          tile
          outlined
          color="primary"
          style="font-weight-bold;"
          @click.stop="dialog = true"
        >
          <v-icon left>vertical_align_top</v-icon>Importer ma commande -
          fichier Excel
        </v-btn>
      </v-col>

      <v-divider class="my-3" />

      <!-- -------- -->
      <!-- Produits -->
      <!-- -------- -->
      <v-data-table
        :headers="headers"
        :items="lignes"
        dense
        :sort-desc="[false]"
        :custom-sort.sync="sortFavoris"
        disable-filtering
        disable-pagination
        hide-default-footer
        no-data-text="Veuillez ajouter un article à votre commande"
      >
        <!-- ----------- -->
        <!-- code SAQ    -->
        <!-- ----------- -->
        <template v-slot:item.noProduit="{ item }">
          <span style="font-size: 12px;">{{ item.noProduit }}</span>
        </template>

        <!-- ------------------------------->
        <!-- Description + Type catégorie -->
        <!-- ------------------------------->
        <template v-slot:item.descriptionProduit="{ item }">
          <div>
            <span style="font-size: 12px;">{{ item.descriptionProduit }} {{ item.millesime }}</span>
          </div>
          <div>
            <template
              v-if="
                item.produitData != null &&
                  item.produitData.typeCategorie != null
              "
            >
              <span
                style="font-size: 12px;"
              >{{ item.produitData.typeCategorie.fr }}, {{ item.formatMl }} ml</span>
            </template>
          </div>
        </template>

        <!-- ------------- -->
        <!-- Catégorie MRP -->
        <!-- ------------- -->

        <template v-slot:item.categorieMRP="{ item }">
          <template
            v-if="
              item.produitData != null && item.produitData.categorieMRP != null
            "
          >
            <span style="font-size: 12px;">
              {{
              item.produitData.categorieMRP.fr
              }}
            </span>
          </template>

          <template v-else>
            <span style="font-size: 12px;">{{ item.categorieMRP.fr }}</span>
          </template>
        </template>

        <!-- ----------- -->
        <!-- nbCaisses -->
        <!-- ----------- -->
        <template v-slot:item.quantite="{ item }">
          <v-text-field
            v-model="item.quantite"
            v-mask="fmtQte"
            class="pa-0 ma-0 mb-1"
            reverse
            hide-details
            @input="majQte(item)"
          />
        </template>

        <!-- ---------- -->
        <!-- inventaire -->
        <!-- ---------- -->

        <template v-slot:item.quantiteInventaire="{ item }">
          <div
            v-if="afficherInventaire(item) < item.quantite"
            class="messageErreur"
          >La quantité commandée est supérieure à la quantité disponible.</div>
          <div
            v-if="afficherInventaire(item) < item.quantite"
            class="messageErreur"
          >Inventaire disponible: {{ afficherInventaire(item) }} bouteilles</div>
          <div
            v-else-if="afficherInventaire(item) == undefined"
            class="messageErreur"
          >Le produit commandé n'est pas disponible</div>
          <div v-else style="font-size: 12px;">
            <div
              v-if="item.quantiteInventaireMontreal < 100"
              style="font-size: 12px;"
            >Inventaire en quantité limitée</div>

            <div v-else style="font-size: 12px;">Disponible</div>
          </div>
        </template>

        <!-- ------- -->
        <!-- prix    -->
        <!-- ------- -->
        <template v-slot:item.prix="{ item }">
          <div style="font-size: 12px;">{{ $fmtDecimal(item.prix) }} $</div>
          <div
            v-if="item.rabaisPromotion != null"
            style="font-size: 12px; color:#7E003F; font-weight:bold;"
          >(Rabais de {{ $fmtDecimal(item.rabaisPromotion) }} $)</div>
        </template>

        <!-- ----- -->
        <!-- total -->
        <!-- ----- -->
        <template v-slot:item.total="{ item }">
          <span style="font-size: 12px;">{{ $fmtDecimal(item.total) }} $</span>
        </template>

        <!-- --------------- -->
        <!-- Colonne actions -->
        <!-- --------------- -->
        <template v-slot:item.supprimer="{ item }">
          <v-icon medium @click="supprimerProduit(item)">delete</v-icon>
        </template>
      </v-data-table>

      <!-- ------ -->
      <!-- Totaux -->
      <!-- ------ -->
      <v-col class="d-flex flex-column align-end text-body-2">
        <div class="d-flex">
          <span class="lgTotal">Sous-total:</span>
          <span class="lgTotal text-right">{{ $fmtDecimal(commande.sousTotal) }} $</span>
        </div>
        <div class="d-flex">
          <span class="lgTotal">TPS:</span>
          <span class="lgTotal text-right">{{ $fmtDecimal(commande.tps) }} $</span>
        </div>
        <div class="d-flex">
          <span class="lgTotal">TVQ:</span>
          <span class="lgTotal text-right">{{ $fmtDecimal(commande.tvq) }} $</span>
        </div>
        <div class="d-flex">
          <span class="lgTotal">Total:**</span>
          <span class="lgTotal text-right">{{ $fmtDecimal(commande.montantCommande) }} $</span>
        </div>
      </v-col>

      <!-- --------- -->
      <!-- Soumettre -->
      <!-- --------- -->

      <div class="d-flex text-left" style="font-size: 16px; font-weight-bold;">NOTE</div>
      <div class="d-flex text-left" style="font-size: 12px; font-weight-bold;">
        Il est à noter que les produits offerts en quantité limitée présentent
        un risque de rupture de stock plus élevé. La disponibilité du produit
        vous sera confirmée au moment du traitement de votre commande.
      </div>
      <div style="font-size: 12px;">
        Pour les produits millésimés, il se peut que le millésime en stock
        diffère de celui affiché. Pour vérifier le millésime disponible, appelez
        au Centre de relation clientèle - Restauration.
      </div>
      <div
        class="d-flex text-left pt-2"
        style="font-size: 12px;"
      >* UVC : nombre de bouteilles dans une caisse.</div>
      <div class="mt-1" style="font-size: 12px;">** Le montant total exclu les rabais et promotions.</div>
      <!--<div class="d-flex text-left" style="font-size: 12px;">
        * Prix unitaire : lors de promotion, les prix affichés sont déjà
        déduits.
      </div>-->

      <v-col class="d-flex justify-center my-2">
        <v-btn
          medium
          color="primary"
          style="text-transform: none;"
          :disabled="sending || lignes.length == 0"
          @click="soumettreCommande"
        >Soumettre la commande</v-btn>
      </v-col>

      <v-divider />

      <!-- --------------- -->
      <!-- Listes  Favoris -->
      <!-- --------------- -->

      <div style="font-size: 13px; font-weight-bold;" class="pt-2">MES LISTES DE PRODUITS</div>
      <div style="font-size: 13px;">
        Vous pouvez ajouter tous les produits de votre panier à une liste
        d'achats pour faciliter vos prochaines commandes. Cette fonction
        pratique vous évite de saisir à chaque commande les codes SAQ des
        produits désirés.
      </div>

      <v-col class="mt-2 d-flex justify-center">
        <v-row justify="center" align="start">
          <v-col cols="5" class="d-flex flex-column mx-2">
            <div class="text-subtitle-2">Ajouter à une nouvelle liste</div>
            <div class="d-flex align-center">
              <v-text-field
                v-model.trim="nomNouvelleListe"
                label="Inscrivez le nom de la liste"
                class="text-caption"
                :disabled="lignes.length == 0"
              />
              <v-btn
                class="ml-2"
                medium
                color="primary"
                style="text-transform: none;"
                :disabled="!nomNouvelleListe"
                @click="creerListeFavoris"
              >Créer</v-btn>
            </div>
          </v-col>
          <v-col cols="5" class="d-flex flex-column mx-2">
            <div class="text-subtitle-2">Ajouter à une liste existante</div>
            <div class="d-flex align-center pt-2">
              <v-select
                v-model="listeFavoris"
                :items="listesFavoris"
                placeholder="Choisir"
                no-data-text="Aucune liste"
                dense
                class="text-caption"
                clearable
                single-line
                hide-no-data
                :disabled="lignes.length == 0 || listesFavoris.length == 0"
              >
                <template slot="item" slot-scope="data">{{ data.item.nom }}</template>
                <template slot="selection" slot-scope="data">{{ data.item.nom }}</template>
              </v-select>
              <v-btn
                class="ml-3"
                medium
                color="primary"
                style="text-transform: none;"
                :disabled="!listeFavoris"
                @click="ajouterAListeFavoris"
              >Ajouter à la liste</v-btn>
            </div>
          </v-col>
        </v-row>
      </v-col>

      <!-- -------------------------------------- -->
      <!-- Dialogue pour l'importation d'Articles -->
      <!-- -------------------------------------- -->
      <v-dialog v-model="dialog" persistent max-width="600">
        <v-card>
          <v-card-title class="text-h6">Importer ma commande</v-card-title>
          <v-card-text>
            À partir de votre fichier Excel, copiez la colonne qui contient les
            codes SAQ ou CUP (max de 14 chiffres) et collez la dans le
            rectangle. Ensuite, cliquez sur importer.
            <v-row class="ma-0 mt-6">
              <v-textarea v-model="produitsEnLot" clearable outlined rows="15" />
            </v-row>
          </v-card-text>
          <v-card-actions class="justify-center mt-0 pt-0 pb-3">
            <v-btn text small @click="dialog = false">Annuler</v-btn>
            <v-btn
              medium
              color="primary"
              style="text-transform: none;"
              @click="ajouterProduitsEnLot"
            >Importer</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>

<script>
import i18n from '@/plugins/i18n'
import { mask } from '@titou10/v-mask'
export default {
  name: 'CommandeTP',
  directives: { mask },
  data() {
    return {
      idProduitAjout: null,
      produitsEnLot: null,
      nomNouvelleListe: null,
      listeFavoris: null,
      listesFavoris: [],
      listeProduitQuantiteInsuffisante: [],
      commandeTPData: null,
      messageProduitInactif: '',
      sending: false,
      // Utils
      idProduitAjoutMask: '###############',
      dialog: false,
      loading: false,
      fmtQte: '#####',
      headers: [
        {
          text: 'Code SAQ',
          value: 'noProduit',
          width: '100px',
        },
        {
          text: 'Description',
          value: 'descriptionProduit',
          width: '300px',
        },
        { text: 'Catégorie', value: 'categorieMRP' },
        { text: 'UVC*', value: 'uvc', align: 'left' },
        {
          text: 'Inventaire',
          value: 'quantiteInventaire',
          sortable: false,
          align: 'left',
        },
        {
          text: 'Qté btle(s)',
          value: 'quantite',
          sortable: false,
          align: 'right',
          width: '100px',
        },
        {
          text: 'Prix unitaire',
          value: 'prix',
          sortable: false,
          align: 'right',
          width: '200px',
        },
        {
          text: 'Total',
          value: 'total',
          sortable: false,
          align: 'right',
          width: '100px',
        },
        {
          text: 'Supprimer',
          value: 'supprimer',
          sortable: false,
          align: 'center',
        },
      ],
    }
  },
  computed: {
    commande: function () {
      return this.$store.getters.commande
    },
    lignes: function () {
      return this.$store.getters.commande.lignes
    },
    francais: function () {
      return i18n.locale === 'fr'
    },
    centreTraitement: function () {
      return this.$store.getters.currentUser.clientData.centreTraitement
    },
  },
  beforeMount() {
    console.log('beforeMount')
    this.lireListesfavoris()
  },
  methods: {
    afficherInventaire(item) {
      if (this.centreTraitement == 'CDM') {
        if (Number(item.quantiteInventaireMontreal) != undefined) {
          return Number(item.quantiteInventaireMontreal)
        } else if (Number(item.quantiteInventaireMontreal) == undefined) {
          return Number(item.produitData.quantiteInventaireMontreal)
        }
      } else {
        if (Number(item.quantiteInventaireQuebec) != undefined) {
          return Number(item.quantiteInventaireQuebec)
        } else if (Number(item.quantiteInventaireQuebec) == undefined) {
          return Number(item.produitData.quantiteInventaireQuebec)
        }
      }
    },

    ajouterProduit() {
      console.log('ajouterProduit: ' + this.idProduitAjout)

      if (this.idProduitAjout != null) {
        for (let i = 0; i < this.lignes.length; i++) {
          if (this.lignes[i].idProduit === Number(this.idProduitAjout)) {
            this.$store.dispatch('afficherError', {
              texte: 'Ce produit est déja dans la liste des produits',
              duree: 5,
            })
            return
          }
        }

        axios
          .get(`/produittp/selonproduit/${this.idProduitAjout}`)
          .then((response) => {
            let resp = response.data
            let msg = null
            let ppp = []
            switch (resp.codeRetour) {
              case 'OK':
                this.idProduitAjout = null

                if (resp.resultat.indActif == false) {
                  this.messageProduitInactif =
                    "Ce code de produit n'existe pas, ou le produit n'est pas disponible ou il a changé de code. Veuillez réessayer en inscrivant un autre code SAQ."
                  return
                } else {
                  if (this.centreTraitement == 'CDQ') {
                    // if (resp.resultat.indPreference6 == false) {
                    resp.resultat.quantiteInventaireQuebec =
                      resp.resultat.quantiteInventaireQuebec +
                      resp.resultat.quantiteInventaireMontreal
                    // }
                  }
                  ppp.push(resp.resultat)
                  this.$store.dispatch('ajouterProduitLot', ppp)
                  this.messageProduitInactif = ''
                  return
                }

              case 'W001':
                this.$store.dispatch(
                  'afficherInfo',
                  "Il n'est pas possible de commander ce produit"
                )
                return

              default:
                msg = this.$fmtApiErr(resp)
                console.log(msg)
                this.$store.dispatch('afficherError', msg)
                break
            }
          })
          .catch((error) => {
            console.log('error=' + error)
            let msg = this.$fmtAxiosErr(error)
            this.$store.dispatch('afficherError', msg)
          })
      }
    },

    mergerListe(produitsDuLot) {
      console.log('mergerListe')

      let ppp = []
      ext: for (let i = 0; i < produitsDuLot.length; i++) {
        if (this.centreTraitement == 'CDQ') {
          //  if (produitsDuLot[i].indPreference6 == false) {
          produitsDuLot[i].quantiteInventaireQuebec =
            produitsDuLot[i].quantiteInventaireQuebec +
            produitsDuLot[i].quantiteInventaireMontreal
          //  }
        }

        for (let j = 0; j < this.lignes.length; j++) {
          if (produitsDuLot[i].noProduit === this.lignes[j].noProduit) {
            // Existe deja...
            continue ext
          }
        }

        ppp.push(produitsDuLot[i])
      }
      this.$store.dispatch('ajouterProduitLot', ppp)
      // this.lignes.sort((a, b) => a.idProduit - b.idProduit)
    },

    supprimerProduit(ligne) {
      this.$store.dispatch('supprimerLigne', ligne)
    },

    majQte(item) {
      console.log('majQte ' + item.quantite)

      if (item.quantite <= 0) {
        this.$store.dispatch(
          'afficherInfo',
          'La quantité doit être plus grande que 0'
        )
        return
      }

      // DF me demandez pas pourquoi ca marche.. sans doute pour laisser le temps a v-mask de faire sa job
      this.$nextTick(() => {
        this.$store.dispatch('modifierQte', item)
      })
    },

    sortFavoris(items, index, desc) {
      items.sort((a, b) => {
        // typeCategorie
        if (index[0] == 'categorieMRP') {
          if (!desc[0]) return a.typeCategorie.fr < b.typeCategorie.fr ? -1 : 1
          else return b.typeCategorie.fr < a.typeCategorie.fr ? -1 : 1
        } else if (index[0] == 'pays') {
          if (!desc[0]) return a.pays.fr < b.pays.fr ? -1 : 1
          else return b.pays.fr < a.pays.fr ? -1 : 1
        }
        // Autres colonnes
        else {
          if (!desc[0]) return a[index] < b[index] ? -1 : 1
          else return b[index] < a[index] ? -1 : 1
        }
      })
      return items
    },

    creerListeFavoris() {
      let produits = []
      for (let i = 0; i < this.lignes.length; i++) {
        produits.push({ noProduit: this.lignes[i].noProduit })
      }

      axios
        .put('/favoristp/creerliste', {
          nom: this.nomNouvelleListe,
          produits: produits,
        })
        .then((response) => {
          let resp = response.data
          let msg = null
          switch (resp.codeRetour) {
            case 'OK':
              this.nomNouvelleListe = null
              this.$store.dispatch(
                'afficherInfo',
                'Liste de favoris crée avec succès'
              )
              this.lireListesfavoris()
              return

            case 'W001':
              this.$store.dispatch('afficherError', "Ce produit n'existe pas")
              return

            default:
              msg = this.$fmtApiErr(resp)
              console.log(msg)
              this.$store.dispatch('afficherError', msg)
              return
          }
        })
        .catch((error) => {
          console.log('error=' + error)
          let msg = this.$fmtAxiosErr(error)
          this.$store.dispatch('afficherError', msg)
        })
    },
    ajouterAListeFavoris() {
      let produits = []
      for (let i = 0; i < this.lignes.length; i++) {
        produits.push({ noProduit: this.lignes[i].noProduit })
      }

      axios
        .post(
          `/favoristp/ajouteralisteexistante/${this.listeFavoris.idListe}`,
          produits
        )
        .then((response) => {
          let resp = response.data
          let msg = null
          if (resp.codeRetour == 'OK') {
            this.nomNouvelleListe = null
            this.$store.dispatch(
              'afficherInfo',
              'Produits ajoutés à la liste avec succès'
            )
            this.lireListesfavoris()
            return
          } else {
            msg = this.$fmtApiErr(resp)
            console.log(msg)
            this.$store.dispatch('afficherError', msg)
            return
          }
        })
        .catch((error) => {
          console.log('error=' + error)
          let msg = this.$fmtAxiosErr(error)
          this.$store.dispatch('afficherError', msg)
        })
    },
    soumettreCommande() {
      if (!confirm('Êtes vous sûr de vouloir soumettre cette commande ?')) {
        return
      }

      for (let i = 0; i < this.lignes.length; i++) {
        console.log(this.lignes[i].quantite)
        if (this.lignes[i].quantite == 0) {
          this.$store.dispatch(
            'afficherInfo',
            "Un des produits n'a pas de quantités de bouteilles"
          )
          return
        }
      }

      this.sending = true

      this.$store.getters.commande.noClientJDE =
        this.$store.getters.usagerConnecteInfosJDE.noClientJDE

      axios
        .post('/commandetp/soumettrecommande', this.$store.getters.commande)
        .then((response) => {
          let resp = response.data
          let msg = null
          switch (resp.codeRetour) {
            case 'OK':
              this.$store.dispatch('afficherSuccess', {
                texte:
                  'La commande no ' +
                  "<span style='font-size: 20px; font-weight-bold'>" +
                  resp.resultat.noCommande +
                  '</span>' +
                  ' est enregistrée avec succès',
                duree: 30,
              })

              this.$store.dispatch('initialiserCommande')
              this.$router.push('accueil')
              return
            case 'X001':
              this.$store.dispatch(
                'afficherError',
                'La commande ne peut être effectuée pour le moment, veuillez essayer de nouveau plus tard'
              )
              return
            case 'V010':
              this.listeProduitQuantiteInsuffisante = resp.resultat
              console.log('Un des produits sans inventaire')

              for (let i = 0; i < this.lignes.length; i++) {
                for (
                  let j = 0;
                  j < this.listeProduitQuantiteInsuffisante.length;
                  j++
                ) {
                  if (
                    this.lignes[i].noProduit ===
                    Number(this.listeProduitQuantiteInsuffisante[j].produit)
                  ) {
                    if (this.centreTraitement == 'CDM') {
                      this.lignes[i].quantiteInventaireMontreal =
                        this.listeProduitQuantiteInsuffisante[j].quantite
                    } else {
                      this.lignes[i].quantiteInventaireQuebec =
                        this.listeProduitQuantiteInsuffisante[j].quantite
                    }
                  }
                }
              }
              break
            default:
              msg = this.$fmtApiErr(resp)
              console.log(msg)
              this.$store.dispatch('afficherError', msg)
              break
          }
        })
        .catch((error) => {
          console.log('error=' + error)
          let msg = this.$fmtAxiosErr(error)
          this.$store.dispatch('afficherError', msg)
        })
        .finally(() => {
          this.sending = false
        })
    },

    ajouterProduitsEnLot() {
      console.log('ajouterProduitsEnLot')

      axios({
        url: `produittp/lot`,
        method: 'post',
        data: this.produitsEnLot,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
        .then((response) => {
          let resp = response.data
          let ligne = {}
          let msg = null

          switch (resp.codeRetour) {
            case 'OK':
              this.mergerListe(resp.resultat)
              this.dialog = false
              this.$store.dispatch(
                'afficherSuccess',
                'Les produits ont été ajoutés à la commande avec succès'
              )
              this.produitsEnLot = null
              return

            case 'V002':
              msg =
                'Certaines lignes sont invalides ou ne contiennent pas des codes articles valides: ' +
                resp.messages.join(', ')
              this.$store.dispatch('afficherWarning', { texte: msg, duree: 30 })
              return

            default:
              msg = this.$fmtApiErr(resp)
              console.log(msg)
              this.$store.dispatch('afficherError', msg)
              break
          }
        })
        .catch((error) => {
          console.log('error=' + error)
          let msg = this.$fmtAxiosErr(error)
          this.$store.dispatch('afficherError', msg)
        })
    },

    lireListesfavoris() {
      console.log('lireListesfavoris')
      this.loading = true
      axios
        .get('/favoristp/client')
        .then((response) => {
          let resp = response.data
          let msg = null
          switch (resp.codeRetour) {
            case 'OK':
            case 'W001':
              this.listesFavoris = resp.resultat
              break
            default:
              this.listesFavoris = []
              msg = this.$fmtApiErr(resp)
              console.log(msg)
              this.$store.dispatch('afficherError', msg)
              break
          }
        })
        .catch((error) => {
          console.log('error=' + error)
          let msg = this.$fmtAxiosErr(error)
          this.$store.dispatch('afficherError', msg)
        })
        .finally(() => (this.loading = false))
    },
  },
}
</script>

<style scoped>
.lgTotal {
  min-width: 80px;
  font-size: 14px;
}

.messageErreur {
  font-size: 13px;
  color: red;
  font-weight: bold;
}

.button {
  height: 14px;
  width: 282px;
  font-size: 12px;
  font-weight: bold;
  letter-spacing: 0.43px;
  line-height: 16px;
  text-align: center;
  box-sizing: border-box;
  height: 14px;
  width: 338px;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 5px;
  background-color: rgba(98, 2, 238, 0);
}
</style>
